import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../context/LocaleContext';
import LowerFooter from '../Components/LowerFooter';
import { paths } from '../routes/paths';
import './LandingPages.css';
import './LocationPage.css';

function LocationPinIcon() {
  return (
    <svg
      className="location_hero_pin"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M32 4C21.5 4 13 12.5 13 23c0 14.25 19 37 19 37s19-22.75 19-37C51 12.5 42.5 4 32 4Z"
        fill="currentColor"
        opacity="0.18"
      />
      <path
        d="M32 4C21.5 4 13 12.5 13 23c0 14.25 19 37 19 37s19-22.75 19-37C51 12.5 42.5 4 32 4Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <circle cx="32" cy="23" r="7" fill="currentColor" />
    </svg>
  );
}

const MAP_EMBED_SRC =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2494.2481953242086!2d-71.96398252281416!3d-13.522669105093586!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x916dd5fd6e89d925%3A0x5028062beeb7ea6f!2sClinica%20Dental%20Smile%20Up%20%7C%20Ortodoncia%20%2C%20Implante%20%2C%20Odontopediatria.!5e0!3m2!1ses-419!2spe!4v1769210347450!5m2!1ses-419!2spe';

const MAP_DIRECTIONS_URL = 'https://maps.app.goo.gl/ZcuCg67p7StV3LBU7';

export default function LocationPage() {
  const { t } = useLocale();
  const base = 'orthoPages.pages.location';

  return (
    <div className="landing_page location_page landing_page--left-justified landing_page--split-layout landing_page--split-transparent">
      <section className="location_top landing_hero_ortho">
        <header className="landing_hero landing_hero_ortho landing_hero--split landing_hero--transparent landing_hero--left-justified location_hero_head">
          <div className="landing_inner landing_hero_inner">
            <div className="landing_hero_text">
              <h1 className="landing_h1">{t(`${base}.h1`)}</h1>
              <p className="landing_sub">{t(`${base}.intro`)}</p>
            </div>
            <div className="location_hero_icon landing_hero_media">
              <LocationPinIcon />
            </div>
          </div>
        </header>
      </section>

      <section className="location_map_zone">
        <div className="landing_inner location_map_wrap">
          <section className="location_block" aria-label={t('navMega.nextStep.location')}>
            <div className="location_block_map">
              <iframe
                title={t('contact.mapTitle')}
                className="location_map_iframe"
                src={MAP_EMBED_SRC}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
            <div className="location_actions">
              <a
                className="location_action location_action--primary"
                href={MAP_DIRECTIONS_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('contact.directions')}
              </a>
              <a className="location_action" href="tel:+5184607539">
                {t('contact.callClinic')}
              </a>
              <Link className="location_action location_action--cta" to={paths.reservas}>
                {t('orthoPages.common.bookCta')}
              </Link>
            </div>
          </section>
        </div>
      </section>

      <main className="landing_inner landing_main landing_main--half landing_main--left-justified location_main">
        <section className="landing_section location_section">
          <h2 className="landing_h2">{t(`${base}.sections.s1.title`)}</h2>
          <p className="landing_p">{t(`${base}.sections.s1.p1`)}</p>
        </section>

        <section className="landing_section location_section">
          <h2 className="landing_h2">{t(`${base}.sections.s2.title`)}</h2>
          <p className="landing_p">{t(`${base}.sections.s2.p1`)}</p>
        </section>

        <section className="landing_section location_section">
          <h2 className="landing_h2">{t(`${base}.sections.s3.title`)}</h2>
          <p className="landing_p">{t(`${base}.sections.s3.p1`)}</p>
        </section>
      </main>

      <LowerFooter />
    </div>
  );
}
